import React, { useContext, useState, useEffect } from "react";
import Swal from "sweetalert2";
import {  useNavigate, useParams } from 'react-router-dom';
import { resetPasswordCheckUUID, resetPasswordConfirm  } from "../../api/auth.ts";
import { TranslatorContext } from "../../context/Translator";
import { ButtonComponent, AnchorComponent } from "../../components/elements";
import { LegendFieldComponent, LegendTextareaComponent, IconFieldComponent } from "../../components/fields";

import LogoComponent from "../../components/LogoComponent";

export default function ResetPasswordNewPasswordPage() {
  const { t } = useContext(TranslatorContext);
  const navigate = useNavigate();

  const { uuid } = useParams()
  const verificationCode = localStorage.getItem("verificationCode");

  const [passwordError, setPasswordErr] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  

  const [formData, setFormData] = useState({
    password: "",
    confirmPassword:''
    });

  const [displayPage, setDisplayPage] = useState(true);

  const [nombrePila, setNombrePila] = useState("");
  const [email, setEmail] = useState("");
  const [emailUsuario, setEmailUsuario] = useState("");
  const [disableSubmitButton, setDisableSubmitButton] = useState(false);


  useEffect(() => {

    if(!uuid)
    setDisplayPage(false);
    else
    resetPasswordCheckUUID(uuid)
      .then((res) => {
        if (res.error === false) {
            setNombrePila(res.usuario_reset_password.usuario_nombre);
            setEmail(res.usuario_reset_password.usuario_email);
            setEmailUsuario(res.usuario_reset_password.usuario_email.split("@")[0]);
              
          setDisplayPage(true);
        } else {
          setDisplayPage(false);
        }
      })

  }, [uuid]);
 
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleValidation = (e)=>{
    const passwordInputValue = e.target.value.trim();
    const passwordInputFieldName = e.target.name;

    //for password
    if(passwordInputFieldName==='password'){
      const uppercaseRegExp   = /(?=.*?[A-Z])/;
      const lowercaseRegExp   = /(?=.*?[a-z])/;
      const specialCharRegExp = /(?=.*?[#?!@$%^&()*+._-])/;
      const minLengthRegExp   = /.{8,}/;
      const digitsRegExp      = /(?=.*?[0-9])/;
      const passwordLength =      passwordInputValue.length;
      const uppercasePassword =   uppercaseRegExp.test(passwordInputValue);
      const lowercasePassword =   lowercaseRegExp.test(passwordInputValue);
      const specialCharPassword = specialCharRegExp.test(passwordInputValue);
      const minLengthPassword =   minLengthRegExp.test(passwordInputValue);
      const digitsPassword =      digitsRegExp.test(passwordInputValue);

      // check password include nombrePila in uppercase
      const nombrePilaInPassword = passwordInputValue.toUpperCase().includes(nombrePila.toUpperCase());
      const emailInPassword = passwordInputValue.toUpperCase().includes(email.toUpperCase());
      const emailUsuarioInPassword = passwordInputValue.toUpperCase().includes(emailUsuario.toUpperCase());

      let errMsg ="";
      if(passwordLength===0){
              errMsg="Debe ingresar una contraseña";
      }else if(!uppercasePassword){
              errMsg="Debe contener al menos una Mayúscula";
      }else if(!lowercasePassword){
              errMsg="Debe contener al menos una Minúscula";
      }else if(!specialCharPassword){
              errMsg="Debe contener al menos un caracter especial";
      }else if(!minLengthPassword){
              errMsg="Debe contener al menos 8 caracteres";
      }else if(!digitsPassword){
              errMsg="Debe contener al menos un número";
      }else if(nombrePilaInPassword){
              errMsg="No debe contener su nombre";
      }else if(emailInPassword){
              errMsg="No debe contener su email";
      }else if(emailUsuarioInPassword){
              errMsg="No debe contener el nombre de usuario de su email";
      }else{
          errMsg="";
      }
      setPasswordErr(errMsg);
    }
    // for confirm password
    if(passwordInputFieldName=== "confirmPassword" || (passwordInputFieldName==="password" && formData.confirmPassword.length>0) ){
      if(formData.confirmPassword!==formData.password)
      {
      setConfirmPasswordError("Las contraseñas no coinciden");
      }else{
      setConfirmPasswordError("");
      }
    }
}

  const handleSubmit = (e) => {
    
    e.preventDefault();

    e.preventDefault();
    try {
      setDisableSubmitButton(true)

      // Validar que no exista error de validación. passwordError y confirmPasswordError deben estar vacíos.
      // Además, realizar una doble validación de la cantidad minima de caracteres para evitar que se valide sin ingresar datos en los input.

      if(passwordError !== "" || confirmPasswordError !== ""){
        Swal.fire({icon: 'warning', text: "Las contraseñas no cumplen los requisitos mínimos." })
        setDisableSubmitButton(false)
        return;
      }

      if(!uuid){
        Swal.fire({icon: 'warning', text: "URL de recuperación de contraseña inválida." })
        setDisableSubmitButton(false)
        return;
      }

      resetPasswordConfirm(uuid, formData.password, formData.confirmPassword)
      .then((res) => {
        if( res.error === false ) {
            Swal.fire({icon: 'success', text: 'Contraseña actualizada correctamente.'});
          localStorage.setItem("verificationCode", "");
          navigate("/");
        } else {
            Swal.fire({icon: 'warning', text: res.msg })
          setDisableSubmitButton(false)
        }
      })


    } catch (err) {
        Swal.fire({title: 'Error', text: 'Error al realizar cambio de contraseña. Si el problema persiste contacte al administrador.' })
      setDisableSubmitButton(false)
    }

   
  };

  

  return (
    <div>
     { displayPage ?
        <div className="mc-auth">
          <img src="images/Login.png" alt="pattern" className="mc-auth-pattern mc-auth-pattern-desktop" />
      <img 
        src="images/Loginphone.png" 
        alt="pattern" 
        className="mc-auth-pattern mc-auth-pattern-mobile"
        onError={(e) => {
          // Fallback a la imagen desktop si la móvil no existe
          e.target.src = "images/Login.png";
        }}
      />
          <div className="mc-auth-group" style={{
    maxWidth: "600px", // Ajusta el ancho máximo
    width: "100%",
    margin: "0 auto", // Centra el formulario
  }}>
            <br></br>
         <br></br>
          <br></br>
           <br></br>
            <br></br>
             <br></br>
              <br></br>
               <br></br>
            <h4 className="mc-auth-title">Confirmar nuevo password</h4>
            <form className="mc-auth-form" onSubmit={handleSubmit} >
            <div className="text-left text-sm font-semibold text-gray-600 mb-7" >
            <h5 className="mc-duel-text-title">Su nueva contraseña debe cumplir las siguientes políticas de seguridad:</h5>
             
                <ul className="mc-user-metalist">
                                            <li><i className="material-icons">check</i><span>Mínimo de 8 carácteres.</span></li>
                                            <li><i className="material-icons">check</i><span>Contener al menos una letra Mayúscula y una Minúscula.</span></li>
                                            <li><i className="material-icons">check</i><span>Contener al menos un caracter especial (#?!@$%^&+*.-)</span></li>
                                            <li><i className="material-icons">check</i><span>Contener al menos un número.</span></li>
                                            <li><i className="material-icons">check</i><span>No incluir el nombre de la cuenta de usuario (email).</span></li>
                                            <li><i className="material-icons">check</i><span>No incluir su nombre de pila.</span></li>

                                        </ul>
            </div>

              
                <IconFieldComponent icon="add_moderator" type="password" placeholder="Nuevo Password" name="password" onChange={handleInputChange}    onKeyUp={handleValidation} classes="w-100 h-lg mb-4" passwordVisible />
                {passwordError !== "" ?
            <p className="mt-0 px-2 py-1 bg-red-50  text-red-600 border border-red-100 rounded text-sm">{passwordError}</p>
            : null }
                <IconFieldComponent icon="verified_user" type="password" placeholder="Confirmar Password" name="confirmPassword"  onChange={handleInputChange}   onKeyUp={handleValidation} classes="w-100 h-lg mb-4" passwordVisible />
                { confirmPasswordError !== "" ?
            <p className="mt-0 px-2 py-1 bg-red-50  text-red-600 border border-red-100 rounded text-sm">{confirmPasswordError}</p>
            : null }
              <ButtonComponent className="mc-auth-btn h-sm" disabled={disableSubmitButton} type="submit">
                Confirmar
              </ButtonComponent>
            </form>
            <div className="mc-auth-navigate">
              <span>¿Recuerdas la contraseña?</span>
              <AnchorComponent to="/login">{t("login")}</AnchorComponent>
            </div>
          </div>
        </div>
       :
       <div className="mc-auth">
          <img
            className="mc-auth-pattern"
            src="images/logo.png"
            alt="pattern"
          />
          <div className="mc-auth-group">
            <LogoComponent
              src="images/logo.png"
              alt="logo"
              href="/ecommerce"
              className="mc-auth-logo"
            />
            <h4 className="mc-auth-title">El código ingresado no es válido o ha expirado.</h4>
           
          </div>
        </div>
     }
    </div>
  );
}